import { useState } from "react";
import { useAddExerciseMutation } from "../../slices/coach/coachSlice";
import { Form, Button } from "react-bootstrap";
import Loader from "../Loader";

const AddExercise = (() => {
    const [showForm, setShowForm] = useState(false);
    const [newExercise, setNewExercise] = useState('');

    const [addExercise, { isLoading }] = useAddExerciseMutation();

    const submitHandler = async (e) => {
        e.preventDefault();

        try {
            await addExercise({
                name: newExercise,
            }).unwrap();
            window.alert("Exercise added.");
        } catch (error) {
            window.alert("Something went wrong");
            console.error(error?.data?.message || error.error);
        }

        setShowForm(false);
    }

    return (
        <>
        {!showForm ? 
        <Button onClick={() => setShowForm(true)}>Add new exercise</Button> : 
        <>
            <Form.Group controlId='type' className='my-1' style={{ maxWidth: '250px' }}>
                <Form.Label>Type</Form.Label>
                <Form.Control 
                    type='text'
                    placeholder='New exercise'
                    maxLength={35}
                    value={newExercise}
                    onChange={(e) => setNewExercise(e.target.value)}>
                </Form.Control>
            </Form.Group>

            <Button className='quiz-btn-dark mt-2' disabled={isLoading} onClick={(e) => submitHandler(e)}>
                Add Exercise
            </Button>
            <Button onClick={() => setShowForm(false)} className='quiz-btn-dark mt-2' disabled={isLoading}>
                Cancel
            </Button>
            { isLoading && <Loader />}
        </>}
        </>
    );
});

export default AddExercise